// extracted by mini-css-extract-plugin
module.exports = {"socialList":"Footer_socialList__kyZZz","socialItem":"Footer_socialItem__KErFo","sites":"Footer_sites__Fl40p","copyright":"Footer_copyright__3OAPV"};